/* eslint-disable import/prefer-default-export */
import request from '@/utils/request';
/**
 * 授权统计列表
 */
export function fetchAuthStatics(dateVal, clientsId, params) {
  const url = dateVal ? `/api/packet/packet-record-list?clients_id=${clientsId}&order[created_at]=desc&between[created_at][]=${dateVal[0]}&between[created_at][]=${dateVal[1]}` : `/api/packet/packet-record-list?clients_id=${clientsId}&order[created_at]=desc`;
  return request({
    url,
    method: 'get',
    params,
  });
}
/**
 * 取消授权课程
 * @param {*} clients_id
 * @param {*} params
 * @returns
 */
export function closeAuthPacket(type, clients_id, data) {
  const url = type === 1 ? `/api/packet/packet-auth-cancel-by-user?clients_id=${clients_id}` : `/api/packet/packet-auth-cancel-by-record?clients_id=${clients_id}`;
  return request({
    url,
    method: 'post',
    data: { ...data },
  });
}
/**
 * 下载授权
 */
export function downAuthStatics(dateVal, clientsId, params) {
  const url = dateVal ? `/api/packet/packet-record-list-export?clients_id=${clientsId}&order[created_at]=desc&between[created_at][]=${dateVal[0]}&between[created_at][]=${dateVal[1]}` : `/api/packet/packet-record-list-export?clients_id=${clientsId}&order[created_at]=desc`;
  return request({
    url,
    method: 'get',
    responseType: 'blob',
    params,
  });
}



// WEBPACK FOOTER //
// ./src/api/courseStatistics.js